import version from "./version";
var path = '/v2';
var v2 = function (url) { return function () { return ({
    version: version(url + path)
}); }; };
export default v2;
